export default "__VITE_ASSET__eOiyXF9l__"